import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import { GardenProvider } from './context/GardenContext'
import { PlantCatalogProvider } from './context/PlantCatalogContext'
import AppLayout from './layouts/AppLayout'
import Welcome from './pages/Welcome'
import ContainerSetup from './pages/ContainerSetup'
import PlantBrowser from './pages/PlantBrowser'
import ContainerDesign from './pages/ContainerDesign'
import Lists from './pages/Lists'

export default function App() {
  return (
    <PlantCatalogProvider>
      <GardenProvider>
        <BrowserRouter>
          <Routes>
            <Route element={<AppLayout />}>
              <Route path="/" element={<Welcome />} />
              <Route path="/setup" element={<ContainerSetup />} />
              <Route path="/browse" element={<PlantBrowser />} />
              <Route path="/design" element={<ContainerDesign />} />
              <Route path="/lists" element={<Lists />} />
            </Route>

            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
      </GardenProvider>
    </PlantCatalogProvider>
  )
}
